import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import './InsuranceVerificationDetails.scss';

type props = {
  className?: string;
};

export const InsuranceNotes: React.FC<props> = ({ className }: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div
      className={`card-container insurance-notes-container ${className || ''}`}
    >
      <Typography variant="size-14" weight="bold" color="color-28">
        {t('insuranceNotes.title')}
      </Typography>

      <ul>
        <li>
          <Typography variant="size-14" color="color-28" className="mt-2">
            {t('insuranceNotes.message1.part1')}{' '}
            <b>{t('insuranceNotes.message1.part2')}</b>
          </Typography>
        </li>

        <li>
          <Typography variant="size-14" color="color-28" className="mt-2">
            {t('insuranceNotes.message2')}
          </Typography>
        </li>

        <li>
          <Typography variant="size-14" color="color-28" className="mt-2">
            {t('insuranceNotes.message3')}
          </Typography>
        </li>

        <li>
          <Typography variant="size-14" color="color-28" className="mt-2">
            {t('insuranceNotes.message4')}
          </Typography>
        </li>

        <li>
          <Typography variant="size-14" color="color-28" className="mt-2">
            {t('insuranceNotes.message5')}
          </Typography>
        </li>
      </ul>
    </div>
  );
};
